(function() {
    'use strict';

    angular.module('app.permisos', []);
})();
